export function PreviousIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="h-4 w-4 fill-current">
      <path d="M7 6a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Zm3.4 6.8V11.2l6.2-4.2A1 1 0 0 1 18 7.8v8.4a1 1 0 0 1-1.4.8l-6.2-4.2Z" />
    </svg>
  );
}

export function PlayIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="h-4 w-4 fill-current">
      <path d="M8.8 6.6A1 1 0 0 1 10.4 5.8l7.8 5.2a1.2 1.2 0 0 1 0 2l-7.8 5.2A1 1 0 0 1 8.8 17V6.6Z" />
    </svg>
  );
}

export function PauseIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="h-4 w-4 fill-current">
      <path d="M8 6.5A1.5 1.5 0 0 1 9.5 5h.2A1.5 1.5 0 0 1 11.2 6.5v11A1.5 1.5 0 0 1 9.7 19h-.2A1.5 1.5 0 0 1 8 17.5v-11Zm4.8 0A1.5 1.5 0 0 1 14.3 5h.2A1.5 1.5 0 0 1 16 6.5v11a1.5 1.5 0 0 1-1.5 1.5h-.2a1.5 1.5 0 0 1-1.5-1.5v-11Z" />
    </svg>
  );
}

export function NextIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="h-4 w-4 fill-current">
      <path d="M17 6a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Zm-3.4 6.8-6.2 4.2a1 1 0 0 1-1.4-.8V7.8A1 1 0 0 1 7.4 7l6.2 4.2v1.6Z" />
    </svg>
  );
}
